import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRingcentral = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1552 1552",
	width: 24,
	height: 24,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#ff7a00",
			d: "m1206.44 0h-860.88c-190.85 0-345.56 154.71-345.56 345.56v860.88c0 190.85 154.71 345.56 345.56 345.56h860.88c190.85 0 345.56-154.71 345.56-345.56v-860.88c0-190.85-154.71-345.56-345.56-345.56zm-860.88 133.38h860.88c117.19 0 212.18 94.99 212.18 212.18v860.88c0 117.19-94.99 212.19-212.18 212.19h-860.88c-117.19 0-212.19-95-212.19-212.19v-860.88c0-117.19 95-212.19 212.19-212.19z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffffff",
			d: "m345.56 133.38h860.88c117.19 0 212.19 94.99 212.19 212.18v860.88c0 117.19-95 212.19-212.19 212.19h-860.88c-117.19 0-212.19-95-212.19-212.19v-860.88c0-117.19 95-212.19 212.19-212.19z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0684bc",
			d: "m527.32 1215.36c3 0.13 6-0.36 8.8-1.44 2.81-1.07 5.36-2.71 7.51-4.81 2.11-2.15 3.76-4.7 4.85-7.5 1.09-2.81 1.6-5.8 1.49-8.81v-635.34c-0.38-2.72-0.13-5.5 0.73-8.11 0.87-2.61 2.33-4.99 4.27-6.94 1.94-1.95 4.31-3.42 6.92-4.3 2.6-0.88 5.38-1.14 8.11-0.77h411.93c2.69-0.29 5.41 0.03 7.95 0.95 2.55 0.92 4.85 2.4 6.73 4.34 1.89 1.94 3.3 4.28 4.14 6.86 0.84 2.56 1.09 5.29 0.72 7.97v198.34c0.39 2.68 0.16 5.41-0.68 7.99-0.83 2.58-2.24 4.93-4.13 6.88-1.89 1.94-4.2 3.43-6.75 4.34-2.56 0.91-5.28 1.22-7.98 0.9h-185.55c-2.76-0.44-5.58-0.23-8.24 0.62-2.66 0.85-5.08 2.31-7.06 4.27-1.99 1.96-3.49 4.36-4.38 7.01-0.89 2.64-1.14 5.46-0.74 8.22v87.89c-0.35 20 1.55 39.99 5.67 59.57 4.29 17.72 11.74 34.52 21.97 49.61l128.04 200.87c4.43 7.17 10.77 12.96 18.31 16.74 7.53 3.77 15.97 5.38 24.37 4.65h167c8.4 0 13.87-2.25 16.4-6.94 1.16-2.78 1.54-5.82 1.09-8.8-0.45-2.97-1.7-5.77-3.62-8.09l-126.97-205.07c-5.85-8.4-3.71-15.04 6.35-20.12l89.07-40.14c28.67-11.58 53.04-31.78 69.73-57.81 15.45-27.4 23.08-58.5 22.07-89.94v-291.3q0-74.12-38.28-112.4-38.28-38.28-112.41-38.28h-577.57q-72.56 0-111.63 38.28-39.06 38.28-39.06 112.4v705.65c-0.13 3 0.37 5.99 1.44 8.8 1.07 2.8 2.71 5.36 4.81 7.51 2.15 2.09 4.7 3.73 7.51 4.8 2.8 1.08 5.8 1.57 8.8 1.45z"
		})
	] }) })]
});
const ForwardRef = forwardRef(SvgRingcentral);
export { ForwardRef as ReactComponent };
